import { render, staticRenderFns } from "./DashRetentionChart.vue?vue&type=template&id=4795622e&scoped=true&"
import script from "./DashRetentionChart.vue?vue&type=script&lang=js&"
export * from "./DashRetentionChart.vue?vue&type=script&lang=js&"
import style0 from "./DashRetentionChart.vue?vue&type=style&index=0&id=4795622e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4795622e",
  null
  
)

export default component.exports